import { siteInfo, heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 pointer-events-none"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-100 text-accent-800 rounded-full text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              <span>{siteInfo.subSlogan}</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              {siteInfo.name}
              <br />
              <span className="text-primary-500">{siteInfo.slogan}</span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mb-8">
              {heroStats.map((stat, idx) => (
                <div key={idx} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-mail-send-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20digital%20art%20illustration%20with%20warm%20coral%20pink%20and%20amber%20orange%20gradient%20tones%2C%20dynamic%20flowing%20shapes%20representing%20entertainment%20news%20and%20social%20media%20buzz%2C%20modern%20geometric%20patterns%20with%20soft%20glowing%20effects%2C%20playful%20and%20energetic%20composition%20with%20smooth%20curves%20and%20overlapping%20translucent%20layers%2C%20clean%20minimal%20aesthetic%20with%20bold%20color%20blocks%2C%20no%20text%20or%20lettering%2C%20warm%20and%20inviting%20atmosphere&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                alt="吃瓜网站线路一 - 最新最全的吃瓜视频资源平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/15 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}